import { QuillCommands } from "components/Quill";
import PerformaLinkBlot from "components/Quill/Blots/PerformaLinkBlot";
import { Mention, MentionBlot, peopleMentionConfig } from "components/Quill/Mention/people";
import { MprcQuillEditor } from "components/Quill/MprcQuillEditor";
import { QuillProps } from "components/Quill/QuillProps";
import * as React from "react";

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    configPeopleMention?: any;
}

const DiscussionEditorComponent: React.ForwardRefRenderFunction<QuillCommands, QuillProps & IProps> = (props, forwardRef) => {
    const runnning = React.useRef<boolean>(false);

    const mentionConfig = props.configPeopleMention ?? peopleMentionConfig;

    const listenPerformaLink = React.useCallback((e: any) => {
        if (e.target && e.target.nodeName == "A" && e.target.classList && e.target.classList[0] == "ql-performa-link") {
            e.preventDefault();
        }
    }, []);

    return <MprcQuillEditor
        {...props}
        ref={forwardRef}
        modules={
            {
                toolbar: {
                    container: [],
                },
                ...mentionConfig
            }
        }
        formats={
            ['mention', 'performaLink']
        }
        onRegisterModules={(Quill: any) => {
            Quill.register('modules/mention', Mention);
            Quill.register(MentionBlot);
            Quill.register(PerformaLinkBlot);
        }}
        onQuillReady={() => {
            document.body.addEventListener("click", listenPerformaLink);
            runnning.current = true;
        }}

        onUnmount={() => {
            if (runnning.current) {
                document.body.removeEventListener("click", listenPerformaLink);
                Array.from(document.body.getElementsByClassName("ql-mention-list-container")).forEach(el => el.remove());
            }
        }}
    />;
};

export const DiscussionEditor = React.forwardRef(DiscussionEditorComponent);
